import { Sidebar } from '../../../components/Sidebar';
import { SharedFoldersList } from '../SharedFoldersList';

export const CollectionsSidebarMobile = ({ onClose, onCollectionDeleted }) => {
  return (
    <Sidebar onClose={onClose} anchor='right'>
      <SharedFoldersList onCollectionDeleted={onCollectionDeleted} />
    </Sidebar>
  );
};
